import { useMutation } from "@apollo/client";
import { FLOORING_VARIATION_DELETE } from "graphql/mutation/flooring-gql";
import { GET_FLOORING_VARIATIONS } from "graphql/query/flooring-gql";
import {
  successNotification,
  errorNotification,
} from "components/request-result";

const useMutationFlooringVariationDelete = (
  id: string | undefined,
  variables: Record<string, any>
) =>
{
  const [ _setMutationFlooringVariationDelete, { loading } ] = useMutation(
    FLOORING_VARIATION_DELETE,
    {
      update(cache, { data })
      {
        const {
          flooringVariationDelete: { label, message },
        } = data;

        cache.evict({
          id: cache.identify({ id, __typename: "FlooringVariation" }),
        });
        cache.gc();

        successNotification({
          title: label.toUpperCase(),
          description: message,
        });
      },
      onError(error)
      {
        errorNotification(error);
      },
      refetchQueries: [
        {
          query: GET_FLOORING_VARIATIONS,
          variables,
        },
      ],
    }
  );

  const handleDelete = async (options: { variables: Record<string, any> }) =>
  {
    await _setMutationFlooringVariationDelete(options);
  };

  return {
    _setMutationFlooringVariationDelete: handleDelete,
    loadingMutationFlooringVariationDelete: loading,
  };
};

export default useMutationFlooringVariationDelete;
